var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayValue !== ""
    ? _c(
        "span",
        {
          class: { "filterable-cell": _vm.isFilterableCell },
          attrs: { title: _vm.title }
        },
        [_vm._v("\n  " + _vm._s(_vm.displayValue) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }